<!--<div *ngIf="recDocVM.dupeBPs && recDocVM.dupeBPs.length > 1" class="info-side-1" [ngStyle]="{'max-height':!isImgVwVisible ? '206px' : '149px' , 'float':!isImgVwVisible ? 'none' : 'left', 'width':!isImgVwVisible ? 'auto' : '50%','min-height':!isImgVwVisible ? 'auto' : '100px'}">
  <p><strong>Additional Docs ({{recDocVM.dupeBPs.length}})</strong></p>
  <dx-list itemSize="20" class="parties-viewport" [dataSource]="recDocVM.dupeBPs" itemTemplate="listItemBy" [showSelectionControls]="true" (onItemClick)="ItemClick($event)" [useNativeScrolling]="false" showScrollBar="always">

    <div class="item-parties" *dxTemplate="let item of 'listItemBy'" style="color:white;">
      {{item.primaryID}} / {{item.secondaryID}} / {{item.docType}}  {{item.recDate | date:"MM-dd-yyyy"}}
    </div>

  </dx-list>
</div>-->
<div class="info-side-1">
  <p><strong>Date</strong> {{recDocVM.docDetail.recDate | date:'MM-dd-yyyy'}}    <strong>Time</strong> {{recDocVM.docDetail.recDate | date:'h:mm a'}}</p>
  <!--<p><strong>Type</strong> {{book}}/{{page}}</p>-->
  <p><strong>Type</strong> {{recDocVM.docDetail.primaryID}} / {{recDocVM.docDetail.secondaryID}} / {{recDocVM.docDetail.docType}}</p>
  <p>
    <strong>City/Town: </strong> {{recDocVM.address}}
  </p>
  <div class="info-side-1-2">
    <p><strong>Instrument No.</strong>  {{recDocVM.docDetail.docID}}</p>
  <p><strong>Document No.</strong>  </p>
    <p>
      <strong>Description</strong> {{recDocVM.docDetail.descript}}
    </p>
    <!--<p *ngIf="recDocVM.amount && recDocVM.amount.length > 4"><strong>Consideration</strong>  {{recDocVM.amount}}</p>-->

  </div>
</div>

<div class="info-side-3" [ngStyle]="{'max-height':!isImgVwVisible ? '106px' : '149px' , 'float':!isImgVwVisible ? 'none' : 'left', 'width':!isImgVwVisible ? 'auto' : '50%','min-height':!isImgVwVisible ? 'auto' : '100px'}">
  <p><strong>Grantors</strong></p>
  <dx-list itemSize="20" class="parties-viewport" [useNativeScrolling]="false" showScrollBar="always">
    <dxi-item *ngFor="let dtor of recDocVM.docTors" class="item-parties" style="color:white;">
      <div *ngIf="dtor.fName !== ''; else lastnameonlytor">
        {{dtor.lastCorpName}}, {{dtor.fName}}
      </div>
      <ng-template #lastnameonlytor>
        {{dtor.lastCorpName}}
      </ng-template>
    </dxi-item>
  </dx-list>
</div>
<div class="info-side-4" [ngStyle]="{'max-height':!isImgVwVisible ? '106px' : '149px' , 'float':!isImgVwVisible ? 'none' : 'left', 'width':!isImgVwVisible ? 'auto' : '50%','min-height':!isImgVwVisible ? 'auto' : '100px'}">
  <p><strong>Grantees</strong></p>
  <dx-list itemSize="20" class="parties-viewport" [useNativeScrolling]="false" showScrollBar="always">
    <dxi-item *ngFor="let dtee of recDocVM.docTees" class="item-parties" style="color:white;">
      <div *ngIf="dtee.fName !== ''; else lastnameonlytee">
        {{dtee.lastCorpName}}, {{dtee.fName}}
      </div>
      <ng-template #lastnameonlytee>
        {{dtee.lastCorpName}}
      </ng-template>
    </dxi-item>
  </dx-list>
</div>
<div class="info-side-5" [ngStyle]="{'max-height':!isImgVwVisible ? '106px' : '149px' , 'float':!isImgVwVisible ? 'none' : 'left', 'width':!isImgVwVisible ? 'auto' : '50%','min-height':!isImgVwVisible ? 'auto' : '100px'}">
  <p><strong>Referred by </strong></p>
  <dx-list itemSize="20" class="parties-viewport" [dataSource]="recDocVM.docRefBy" itemTemplate="listItemBy" (onItemClick)="ItemClick($event)" [useNativeScrolling]="false" showScrollBar="always">

    <div class="item-parties" *dxTemplate="let item of 'listItemBy'" style="color:white;">
      {{item.docType}}:{{item.primaryID}}/{{item.secondaryID}}
    </div>

  </dx-list>
</div>
<div class="info-side-6" [ngStyle]="{'max-height':!isImgVwVisible ? '106px' : '149px' , 'float':!isImgVwVisible ? 'none' : 'left', 'width':!isImgVwVisible ? 'auto' : '50%','min-height':!isImgVwVisible ? 'auto' : '100px'}">
  <p><strong>Refers to </strong></p>
  <dx-list itemSize="20" class="parties-viewport" [dataSource]="recDocVM.docRefTo" itemTemplate="listItemTo" (onItemClick)="ItemClick($event)" [useNativeScrolling]="false" showScrollBar="always">

    <div class="item-parties" *dxTemplate="let item of 'listItemTo'" style="color:white;">
      {{item.docType}}:{{item.primaryID}}/{{item.secondaryID}}
    </div>

  </dx-list>
</div>
<div class="info-side-7" [ngStyle]="{'max-height':!isImgVwVisible ? '106px' : '149px' , 'float':!isImgVwVisible ? 'none' : 'left', 'width':!isImgVwVisible ? 'auto' : '50%','min-height':!isImgVwVisible ? 'auto' : '100px'}">
  <p><strong>Transaction Documents </strong></p>
  <dx-list itemSize="20" class="parties-viewport" [dataSource]="recDocVM.docTrans" itemTemplate="listItem" (onItemClick)="ItemClick($event)" [useNativeScrolling]="false" showScrollBar="always">

    <div class="item-parties" *dxTemplate="let item of 'listItem'" style="color:white;">
      {{item.docType}}:{{item.primaryID}}/{{item.secondaryID}}
    </div>

  </dx-list>
</div>
<div class="info-side-8" [ngStyle]="{'max-height':!isImgVwVisible ? '106px' : '149px' , 'float':!isImgVwVisible ? 'none' : 'left', 'width':!isImgVwVisible ? 'auto' : '50%','min-height':!isImgVwVisible ? 'auto' : '100px'}">
  <p><strong>Consideration </strong></p>
  <p><strong>Locus</strong></p>
  <div *ngFor="let address of recDocVM.docAddress">
    <label> {{address.address}}</label>
  </div>
</div>



<dx-load-panel #loadPanel
               shadingColor="rgba(0,0,0,0.4)"
               [position]="{ of: '#details' }"
               [(visible)]="loadingVisible"
               [showIndicator]="true"
               [showPane]="true"
               [shading]="true"
               [closeOnOutsideClick]="false">

</dx-load-panel>
